import { api } from './api';

export const availableEquipmentApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAvailableEquipment: build.query<any, { accountId: string }>({
      query: ({ accountId }) => {
        const params = new URLSearchParams();
        params.append('accountId', accountId);
        return { url: `available-equipment?${params.toString()}` };
      },
    }),
  }),
});

export const { useGetAvailableEquipmentQuery } = availableEquipmentApi;
